export function SettingsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_2447_6093)">
        <path
          d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1602 16.1023C10.0555 16.1023 9.95001 16.1023 9.84766 16.1023L7.34376 17.5C6.36901 17.1721 5.4649 16.6632 4.67891 16L4.66954 13.1875C4.61407 13.1 4.56172 13.0117 4.51329 12.9211L2.02344 11.5031C1.82733 10.5112 1.82733 9.4904 2.02344 8.49844L4.51094 7.08438C4.56172 6.99453 4.61407 6.90547 4.66719 6.81797L4.67969 4.00547C5.46498 3.34035 6.36885 2.82957 7.34376 2.5L9.84376 3.89766C9.94844 3.89766 10.0539 3.89766 10.1563 3.89766L12.6563 2.5C13.631 2.82788 14.5351 3.33679 15.3211 4L15.3305 6.8125C15.3859 6.9 15.4383 6.98828 15.4867 7.07891L17.975 8.49609C18.1711 9.48806 18.1711 10.5088 17.975 11.5008L15.4875 12.9148C15.4367 13.0047 15.3844 13.0938 15.3313 13.1813L15.3188 15.9938C14.534 16.659 13.6307 17.17 12.6563 17.5L10.1602 16.1023Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2447_6093">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
